import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface QuantityStepperProps {
  label: string;
  value: number;
  onChange: (n: number) => void;
  decLabel: string;
  incLabel: string;
  max?: number;
}
export function QuantityStepper({
  label,
  value,
  onChange,
  decLabel,
  incLabel,
  max = 99
}: QuantityStepperProps) {
  return <div className={`flex items-center justify-between gap-3 rounded-lg px-3 py-2 ${value > 0 ? 'bg-white' : ''}`} data-id="element-583" data-mp="1o649rni4mr1z">
      <span className={`min-w-0 text-[15px] leading-snug ${value > 0 ? 'font-semibold text-ink' : 'text-ink-600'}`} data-id="element-584" data-mp="1t5qj3luu3n5i">{label}</span>
      <div className="flex shrink-0 items-center gap-1" data-id="element-585" data-mp="224ke57sio5gy">
        <button type="button" onClick={() => onChange(Math.max(0, value - 1))} disabled={value === 0} aria-label={`${decLabel}: ${label}`} className="flex h-11 w-11 items-center justify-center rounded-lg border-2 border-ink-200 bg-white text-ink transition-[border-color,opacity] duration-150 ease-out hover:border-ink disabled:opacity-30" data-id="element-586" data-mp="2253syfmvedqr">
          <MinusIcon className="h-4 w-4" data-id="element-587" data-mp="1hri2udbv5eym" />
        </button>
        <span className="w-8 text-center text-base font-bold tabular-nums" aria-live="polite" data-id="element-588" data-mp="1cz8h79hs7125">
          {value}
        </span>
        <button type="button" onClick={() => onChange(Math.min(max, value + 1))} aria-label={`${incLabel}: ${label}`} className="flex h-11 w-11 items-center justify-center rounded-lg border-2 border-ink bg-ink text-white transition-[background-color] duration-150 ease-out hover:bg-ink-700" data-id="element-589" data-mp="18yenfzhnqs1c">
          <PlusIcon className="h-4 w-4" data-id="element-590" data-mp="1ro4jepx5pjuu" />
        </button>
      </div>
    </div>;
}